var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$config.company.url)?_c('p',[_c('a',{attrs:{"href":_vm.$config.company.url,"target":"_blank"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.$config.company.logo}})])]):_c('p',[_c('img',{staticClass:"logo",attrs:{"src":_vm.$config.company.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }